if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name="id"]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        this.cart =
          document.querySelector('cart-notification') ||
          document.querySelector('cart-drawer');

        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.error = false;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.error = false;

        this.submitButton.setAttribute('aria-disabled', 'true');
        this.submitButton.classList.add('loading');

        const spinner = this.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        const mainVariantId = Number(formData.get('id'));
        const mainQuantity = Number(formData.get('quantity') || 1);

        if (!mainVariantId || mainQuantity <= 0) {
          this.handleErrorMessage('No valid product was found to add to cart.');
          this.error = true;
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
          return;
        }

        /*
  Upsell add-ons are handled immediately by assets/upsell-add-on.js.
  Do not append selected upsells here, because that creates duplicate bag quantity
  when the main product is added to cart.
*/

        if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);

          if (typeof this.cart.setActiveElement === 'function') {
            this.cart.setActiveElement(document.activeElement);
          }
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.text())
          .then((responseText) => {
            let response;

            try {
              response = JSON.parse(responseText);
            } catch (parseError) {
              /*
               * Non-JSON response = Shopify bot-protection (hCaptcha)
               * challenge intercepted the AJAX add. Fall back to a native
               * form submit so the customer can solve the challenge.
               */
              this.submitButton.removeAttribute('aria-disabled');
              HTMLFormElement.prototype.submit.call(this.form);
              return;
            }
            if (response.status) {
              if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  errors: response.errors || response.description,
                  message: response.message
                });
              }

              this.handleErrorMessage(
                response.description || response.message || 'There was an error adding to cart.'
              );

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (soldOutMessage) {
                this.submitButton.setAttribute('aria-disabled', 'true');
                const submitText = this.submitButton.querySelector('span');
                if (submitText) submitText.classList.add('hidden');
                soldOutMessage.classList.remove('hidden');
              }

              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response
              });
            }

            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            const quickViewModal = document.getElementById('product-modal');

            if (quickViewModal) {
              quickViewModal.classList.remove('active');
              document.body.classList.remove('quickview-open');
            }

            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    if (typeof this.cart.renderContents === 'function') {
                      this.cart.renderContents(response);
                    }
                  });
                },
                { once: true }
              );

              if (typeof quickAddModal.hide === 'function') {
                quickAddModal.hide(true);
              }
            } else if (typeof this.cart.renderContents === 'function') {
              this.cart.renderContents(response);
            }
          })
          .catch((error) => {
            console.error(error);
            this.handleErrorMessage('There was an error adding to cart.');
            this.error = true;
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');

            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }

            /*
             * Always re-enable unless the variant is sold out. Leaving
             * aria-disabled="true" after a transient error (network,
             * captcha challenge) silently swallows every later click.
             */
            const soldOutShown = this.submitButton.querySelector('.sold-out-message:not(.hidden)');
            if (!soldOutShown) {
              this.submitButton.removeAttribute('aria-disabled');
            }

            if (spinner) spinner.classList.add('hidden');
          });
      }
 
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector('.product-form__error-message-wrapper');

        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
